import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService, EModalSize, EToasterType, EToasterPosition } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { $types } from './FootPrintPortalManager.types'

import { FootPrintPortalManager_inventory_pallet_gridComponent } from './FootPrintPortalManager.inventory_pallet_grid.component';
import { FootPrintPortalManager_inventory_lot_gridComponent } from './FootPrintPortalManager.inventory_lot_grid.component';
import { FootPrintPortalManager_inventory_material_gridComponent } from './FootPrintPortalManager.inventory_material_grid.component';
import { FootPrintPortalManager_inventory_pallet_snapshot_gridComponent } from './FootPrintPortalManager.inventory_pallet_snapshot_grid.component';
import { FootPrintPortalManager_inventory_lot_snapshot_gridComponent } from './FootPrintPortalManager.inventory_lot_snapshot_grid.component';
import { FootPrintPortalManager_inventory_material_snapshot_gridComponent } from './FootPrintPortalManager.inventory_material_snapshot_grid.component';
import { FootPrintPortalManager_inventory_tasks_gridComponent } from './FootPrintPortalManager.inventory_tasks_grid.component';
import { Inventory_total_available_amount_widgetComponent } from './Inventory.total_available_amount_widget.component';
import { Inventory_total_packaged_amount_widgetComponent } from './Inventory.total_packaged_amount_widget.component';
import { Owners_owners_dd_singleComponent } from './Owners.owners_dd_single.component'
import { Owners_projects_dd_singleComponent } from './Owners.projects_dd_single.component'
import { Materials_materials_by_project_dd_multiComponent } from './Materials.materials_by_project_dd_multi.component'
import { Locations_warehouses_dd_singleComponent } from './Locations.warehouses_dd_single.component'
import { FootPrintPortalManager_inventory_aggregation_dd_singleComponent } from './FootPrintPortalManager.inventory_aggregation_dd_single.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => FootPrintPortalManager_inventory_pallet_gridComponent),
    forwardRef(() => FootPrintPortalManager_inventory_lot_gridComponent),
    forwardRef(() => FootPrintPortalManager_inventory_material_gridComponent),
    forwardRef(() => FootPrintPortalManager_inventory_pallet_snapshot_gridComponent),
    forwardRef(() => FootPrintPortalManager_inventory_lot_snapshot_gridComponent),
    forwardRef(() => FootPrintPortalManager_inventory_material_snapshot_gridComponent),
    forwardRef(() => FootPrintPortalManager_inventory_tasks_gridComponent),
    forwardRef(() => Inventory_total_available_amount_widgetComponent),
    forwardRef(() => Inventory_total_packaged_amount_widgetComponent),
    forwardRef(() => Owners_owners_dd_singleComponent),
    forwardRef(() => Owners_projects_dd_singleComponent),
    forwardRef(() => Materials_materials_by_project_dd_multiComponent),
    forwardRef(() => Locations_warehouses_dd_singleComponent),
    forwardRef(() => FootPrintPortalManager_inventory_aggregation_dd_singleComponent),
  ],
  selector: 'FootPrintPortalManager-inventory_hub',
  templateUrl: './FootPrintPortalManager.inventory_hub.component.html'
})
export class FootPrintPortalManager_inventory_hubComponent implements OnInit, OnDestroy, OnChanges {

  inParams: { ownerId?: number, projectId?: number, warehouseId?: number } = { ownerId: null, projectId: null, warehouseId: null };
  //#region Inputs
  @Input('ownerId') set $inParams_ownerId(v: number) {
    this.inParams.ownerId = v;
  }
  get $inParams_ownerId(): number {
    return this.inParams.ownerId;
  }
  @Input('projectId') set $inParams_projectId(v: number) {
    this.inParams.projectId = v;
  }
  get $inParams_projectId(): number {
    return this.inParams.projectId;
  }
  @Input('warehouseId') set $inParams_warehouseId(v: number) {
    this.inParams.warehouseId = v;
  }
  get $inParams_warehouseId(): number {
    return this.inParams.warehouseId;
  }
  //#endregion Inputs

  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  //#endregion
  formGroup: FormGroup = new FormGroup({
    owner: new DatexFormControl(null, { validators: [ Validators.required ], updateOn: 'blur' }),
    project: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    materials: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    warehouse: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    inventory_type: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    inventory_date: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  toolbar = {
      create_material: new ToolModel(new ButtonModel('create_material', new ButtonStyles(null, null), false, 'Create material', 'ms-Icon ms-Icon--Add')
    ),
      lots_hub: new ToolModel(new ButtonModel('lots_hub', new ButtonStyles(null, null), false, 'Lots hub', 'icon-datex-Lot')
    ),
      serials_hub: new ToolModel(new ButtonModel('serials_hub', new ButtonStyles(null, null), false, 'Serials hub', 'icon-datex-SerialNumber')
    )
  };

  actionbar = {
  };

 filters = {
    owner: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['owner'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Owner', true)
,
    project: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['project'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Project', false)
,
    materials: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['materials'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Materials', false)
,
    warehouse: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['warehouse'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Warehouse', false)
,
    inventory_type: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['inventory_type'] as DatexFormControl, 
  ESelectBoxType.chips, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Inventory type', false)
,
    inventory_date: new FieldModel(new DateBoxModel(this.formGroup.controls['inventory_date'] as DatexFormControl, null, false, 'MM/DD/YYYY', 'date')
, new ControlContainerStyles(null, null), 'Inventory date', false)
,
  };


  filtersets = {
  newGroup1: new FieldsetModel('Filters', false, true, false),
  newGroup2: new FieldsetModel('', true, false, true),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      inventory_by_lp: new TabItemModel(
        this.rootTabGroup, 
        'Inventory', 
        ),
      inventory_by_lot: new TabItemModel(
        this.rootTabGroup, 
        'Inventory', 
        ),
      inventory_by_material: new TabItemModel(
        this.rootTabGroup, 
        'Inventory', 
        ),
      inventory_by_pallet_snapshot: new TabItemModel(
        this.rootTabGroup, 
        'Inventory', 
        ),
      inventory_by_lot_snapshot: new TabItemModel(
        this.rootTabGroup, 
        'Inventory', 
        ),
      inventory_by_material_snapshot: new TabItemModel(
        this.rootTabGroup, 
        'Inventory', 
        ),
      tasks: new TabItemModel(
        this.rootTabGroup, 
        'Activity', 
        ),
    };
  
    //#region tabs inParams
    get $tabs_inventory_by_lp_inventory_pallet_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_by_lp_inventory_pallet_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_by_lp_inventory_pallet_grid_inParams_warehouseId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_inventory_by_lp_inventory_pallet_grid_inParams_materialIds: number[];
    get $tabs_inventory_by_lp_inventory_pallet_grid_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_inventory_by_lp_inventory_pallet_grid_inParams_materialIds, expr)) {
        this.cacheValueFor_$tabs_inventory_by_lp_inventory_pallet_grid_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$tabs_inventory_by_lp_inventory_pallet_grid_inParams_materialIds;
    }
  
    get $tabs_inventory_by_lot_inventory_lot_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_by_lot_inventory_lot_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_by_lot_inventory_lot_grid_inParams_warehouseId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_inventory_by_lot_inventory_lot_grid_inParams_materialIds: number[];
    get $tabs_inventory_by_lot_inventory_lot_grid_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_inventory_by_lot_inventory_lot_grid_inParams_materialIds, expr)) {
        this.cacheValueFor_$tabs_inventory_by_lot_inventory_lot_grid_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$tabs_inventory_by_lot_inventory_lot_grid_inParams_materialIds;
    }
  
    get $tabs_inventory_by_material_inventory_material_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_by_material_inventory_material_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_by_material_inventory_material_grid_inParams_warehouseId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_inventory_by_material_inventory_material_grid_inParams_materialIds: number[];
    get $tabs_inventory_by_material_inventory_material_grid_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_inventory_by_material_inventory_material_grid_inParams_materialIds, expr)) {
        this.cacheValueFor_$tabs_inventory_by_material_inventory_material_grid_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$tabs_inventory_by_material_inventory_material_grid_inParams_materialIds;
    }
  
    get $tabs_inventory_by_pallet_snapshot_inventory_pallet_snapshot_grid_inParams_captureDate(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.inventory_date.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_by_pallet_snapshot_inventory_pallet_snapshot_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_by_pallet_snapshot_inventory_pallet_snapshot_grid_inParams_warehouseId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_inventory_by_pallet_snapshot_inventory_pallet_snapshot_grid_inParams_materialIds: number[];
    get $tabs_inventory_by_pallet_snapshot_inventory_pallet_snapshot_grid_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_inventory_by_pallet_snapshot_inventory_pallet_snapshot_grid_inParams_materialIds, expr)) {
        this.cacheValueFor_$tabs_inventory_by_pallet_snapshot_inventory_pallet_snapshot_grid_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$tabs_inventory_by_pallet_snapshot_inventory_pallet_snapshot_grid_inParams_materialIds;
    }
  
    get $tabs_inventory_by_lot_snapshot_inventory_lot_snapshot_grid_inParams_captureDate(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.inventory_date.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_by_lot_snapshot_inventory_lot_snapshot_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_by_lot_snapshot_inventory_lot_snapshot_grid_inParams_warehouseId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_inventory_by_lot_snapshot_inventory_lot_snapshot_grid_inParams_materialIds: number[];
    get $tabs_inventory_by_lot_snapshot_inventory_lot_snapshot_grid_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_inventory_by_lot_snapshot_inventory_lot_snapshot_grid_inParams_materialIds, expr)) {
        this.cacheValueFor_$tabs_inventory_by_lot_snapshot_inventory_lot_snapshot_grid_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$tabs_inventory_by_lot_snapshot_inventory_lot_snapshot_grid_inParams_materialIds;
    }
  
    get $tabs_inventory_by_material_snapshot_inventory_material_snapshot_grid_inParams_captureDate(): string {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.inventory_date.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_by_material_snapshot_inventory_material_snapshot_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    get $tabs_inventory_by_material_snapshot_inventory_material_snapshot_grid_inParams_warehouseId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_inventory_by_material_snapshot_inventory_material_snapshot_grid_inParams_materialIds: number[];
    get $tabs_inventory_by_material_snapshot_inventory_material_snapshot_grid_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_inventory_by_material_snapshot_inventory_material_snapshot_grid_inParams_materialIds, expr)) {
        this.cacheValueFor_$tabs_inventory_by_material_snapshot_inventory_material_snapshot_grid_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$tabs_inventory_by_material_snapshot_inventory_material_snapshot_grid_inParams_materialIds;
    }
  
    cacheValueFor_$tabs_tasks_inventory_tasks_grid_inParams_materialIds: number[];
    get $tabs_tasks_inventory_tasks_grid_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$tabs_tasks_inventory_tasks_grid_inParams_materialIds, expr)) {
        this.cacheValueFor_$tabs_tasks_inventory_tasks_grid_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$tabs_tasks_inventory_tasks_grid_inParams_materialIds;
    }
  
    get $tabs_tasks_inventory_tasks_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    get $tabs_tasks_inventory_tasks_grid_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    cacheValueFor_$tabs_tasks_inventory_tasks_grid_inParams_warehouseIds: number[];
    get $tabs_tasks_inventory_tasks_grid_inParams_warehouseIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value[0];
      
      if(!isEqual(this.cacheValueFor_$tabs_tasks_inventory_tasks_grid_inParams_warehouseIds, expr)) {
        this.cacheValueFor_$tabs_tasks_inventory_tasks_grid_inParams_warehouseIds = expr;
      }
      return this.cacheValueFor_$tabs_tasks_inventory_tasks_grid_inParams_warehouseIds;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_inventory_by_lp', { read: FootPrintPortalManager_inventory_pallet_gridComponent }) $tabs_inventory_by_lp: FootPrintPortalManager_inventory_pallet_gridComponent;
      @ViewChild('$tabs_inventory_by_lot', { read: FootPrintPortalManager_inventory_lot_gridComponent }) $tabs_inventory_by_lot: FootPrintPortalManager_inventory_lot_gridComponent;
      @ViewChild('$tabs_inventory_by_material', { read: FootPrintPortalManager_inventory_material_gridComponent }) $tabs_inventory_by_material: FootPrintPortalManager_inventory_material_gridComponent;
      @ViewChild('$tabs_inventory_by_pallet_snapshot', { read: FootPrintPortalManager_inventory_pallet_snapshot_gridComponent }) $tabs_inventory_by_pallet_snapshot: FootPrintPortalManager_inventory_pallet_snapshot_gridComponent;
      @ViewChild('$tabs_inventory_by_lot_snapshot', { read: FootPrintPortalManager_inventory_lot_snapshot_gridComponent }) $tabs_inventory_by_lot_snapshot: FootPrintPortalManager_inventory_lot_snapshot_gridComponent;
      @ViewChild('$tabs_inventory_by_material_snapshot', { read: FootPrintPortalManager_inventory_material_snapshot_gridComponent }) $tabs_inventory_by_material_snapshot: FootPrintPortalManager_inventory_material_snapshot_gridComponent;
      @ViewChild('$tabs_tasks', { read: FootPrintPortalManager_inventory_tasks_gridComponent }) $tabs_tasks: FootPrintPortalManager_inventory_tasks_gridComponent;
    //#endregion tabs children
    widgets = {
      total_available_amount_widget: new WidgetModel(),
      total_packaged_amount_widget: new WidgetModel(),
    };
  
    //#region widgets inParams
    get $widgets_total_available_amount_widget_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $widgets_total_available_amount_widget_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$widgets_total_available_amount_widget_inParams_materialIds: number[];
    get $widgets_total_available_amount_widget_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$widgets_total_available_amount_widget_inParams_materialIds, expr)) {
        this.cacheValueFor_$widgets_total_available_amount_widget_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$widgets_total_available_amount_widget_inParams_materialIds;
    }
  
    get $widgets_total_available_amount_widget_inParams_warehouseId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value;
      
      return expr;
    }
  
    get $widgets_total_packaged_amount_widget_inParams_warehouseId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.warehouse.control.value;
      
      return expr;
    }
  
    get $widgets_total_packaged_amount_widget_inParams_ownerId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.owner.control.value;
      
      return expr;
    }
  
    get $widgets_total_packaged_amount_widget_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.project.control.value;
      
      return expr;
    }
  
    cacheValueFor_$widgets_total_packaged_amount_widget_inParams_materialIds: number[];
    get $widgets_total_packaged_amount_widget_inParams_materialIds(): number[] {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.materials.control.value;
      
      if(!isEqual(this.cacheValueFor_$widgets_total_packaged_amount_widget_inParams_materialIds, expr)) {
        this.cacheValueFor_$widgets_total_packaged_amount_widget_inParams_materialIds = expr;
      }
      return this.cacheValueFor_$widgets_total_packaged_amount_widget_inParams_materialIds;
    }
  
    //#endregion widgets inParams
  
    //#region widgets children
      @ViewChild('$widgets_total_available_amount_widget', { read:  Inventory_total_available_amount_widgetComponent }) $widgets_total_available_amount_widget: Inventory_total_available_amount_widgetComponent;
      @ViewChild('$widgets_total_packaged_amount_widget', { read:  Inventory_total_packaged_amount_widgetComponent }) $widgets_total_packaged_amount_widget: Inventory_total_packaged_amount_widgetComponent;
    //#endregion widgets children

  //#region filters inParams
  get $fields_owner_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_owner_selector_inParams_projectId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.project.control.value;
    
    return expr;
  }



  get $fields_project_selector_inParams_statusId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = 1;
    
    return expr;
  }



  get $fields_project_selector_inParams_ownerId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.owner.control.value;
    
    return expr;
  }



  get $fields_materials_selector_inParams_projectId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.filters.project.control.value;
    
    return expr;
  }



  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Inventory hub`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Your landing page to view inventory across your projects and assigned warehouses.`;
  }

  constructor(
  private utils: UtilsService,
  private settings: SettingsValuesService,
  private shell: FootPrintPortalManager_ShellService,
  private datasources: FootPrintPortalManager_DatasourceService,
  private flows: FootPrintPortalManager_FlowService,
  private reports: FootPrintPortalManager_ReportService,
  private localization: FootPrintPortalManager_LocalizationService,
  private operations: FootPrintPortalManager_OperationService,
  ) { 
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.inventory_by_lp,
      this.tabs.inventory_by_lot,
      this.tabs.inventory_by_material,
      this.tabs.inventory_by_pallet_snapshot,
      this.tabs.inventory_by_lot_snapshot,
      this.tabs.inventory_by_material_snapshot,
      this.tabs.tasks,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Inventory Hub';
    
    const $hub = this;
    const $utils = this.utils;

    (this.filters.inventory_type.control as SelectBoxModel).reset(4);

    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
    this.formGroup
      .controls['owner']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_owner_change();
      });
    this.formGroup
      .controls['project']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_project_change();
      });
    this.formGroup
      .controls['inventory_type']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_inventory_type_change();
      });
    this.formGroup
      .controls['inventory_date']
      .valueChanges
      .pipe(
        takeUntil(this.$unsubscribe$)
      )
      .subscribe(() => {
        this.on_inventory_date_change();
      });
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region widgets children
    if (childToSkip !== '$widgets_total_available_amount_widget') {
      if (!isNil(this.$widgets_total_available_amount_widget) && !this.widgets.total_available_amount_widget.hidden) {
        this.$widgets_total_available_amount_widget.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$widgets_total_packaged_amount_widget') {
      if (!isNil(this.$widgets_total_packaged_amount_widget) && !this.widgets.total_packaged_amount_widget.hidden) {
        this.$widgets_total_packaged_amount_widget.refresh(true, false, null);
      }
    }
    //#endregion widgets children
    //#region tabs children
    if (childToSkip !== '$tabs_inventory_by_lp') {
      if (!isNil(this.$tabs_inventory_by_lp) && !this.tabs.inventory_by_lp.hidden) {
        this.$tabs_inventory_by_lp.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_inventory_by_lot') {
      if (!isNil(this.$tabs_inventory_by_lot) && !this.tabs.inventory_by_lot.hidden) {
        this.$tabs_inventory_by_lot.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_inventory_by_material') {
      if (!isNil(this.$tabs_inventory_by_material) && !this.tabs.inventory_by_material.hidden) {
        this.$tabs_inventory_by_material.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_inventory_by_pallet_snapshot') {
      if (!isNil(this.$tabs_inventory_by_pallet_snapshot) && !this.tabs.inventory_by_pallet_snapshot.hidden) {
        this.$tabs_inventory_by_pallet_snapshot.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_inventory_by_lot_snapshot') {
      if (!isNil(this.$tabs_inventory_by_lot_snapshot) && !this.tabs.inventory_by_lot_snapshot.hidden) {
        this.$tabs_inventory_by_lot_snapshot.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_inventory_by_material_snapshot') {
      if (!isNil(this.$tabs_inventory_by_material_snapshot) && !this.tabs.inventory_by_material_snapshot.hidden) {
        this.$tabs_inventory_by_material_snapshot.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_tasks') {
      if (!isNil(this.$tabs_tasks) && !this.tabs.tasks.hidden) {
        this.$tabs_tasks.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: FootPrintPortalManager_inventory_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  $hub.title = 'Inventory Hub'
  
  $hub.tabs.tasks.hidden = true;
  
  $hub.tabs.inventory_by_lp.hidden = true;
  $hub.tabs.inventory_by_lot.hidden = true;
  $hub.tabs.inventory_by_material.hidden = true;
  
  $hub.tabs.inventory_by_material_snapshot.hidden = true;
  $hub.tabs.inventory_by_lot_snapshot.hidden = true;
  $hub.tabs.inventory_by_pallet_snapshot.hidden = true;
  
  //Initially hide the widgets, we only want them to show when at least an owner is selected
  $hub.widgets.total_available_amount_widget.hidden = true;
  $hub.widgets.total_packaged_amount_widget.hidden = true;
  
  if ($utils.isDefined($hub.inParams.ownerId) || $utils.isDefined($hub.inParams.projectId)) {
      $hub.filters.owner.control.value = $hub.inParams.ownerId
      $hub.filters.project.control.value = $hub.inParams.projectId
  
      $hub.widgets.total_available_amount_widget.hidden = false;
      $hub.widgets.total_packaged_amount_widget.hidden = false;
  
      $hub.tabs.inventory_by_material.hidden = false;
      $hub.tabs.tasks.hidden = false;
      $hub.tabs.inventory_by_material.activate();
  }
  else {
  
      // Default to the first owner and project based on the users data access role
      const project = (await $datasources.Owners.ds_get_project_top1.get({})).result;
      if ($utils.isDefined(project)) {
  
          const projectId = project.Id;
          const ownerId = project.OwnerId;
  
          if ($utils.isAllDefined(projectId, ownerId)) {
              $hub.filters.project.control.value = projectId;
              $hub.filters.owner.control.value = ownerId;
  
              $hub.widgets.total_available_amount_widget.hidden = false;
              $hub.widgets.total_packaged_amount_widget.hidden = false;
  
              $hub.tabs.inventory_by_material.hidden = false;
              $hub.tabs.tasks.hidden = false;
              $hub.tabs.inventory_by_material.activate();
          }
      }
  }
  
  if ($utils.isDefined($hub.inParams.warehouseId)) {
      $hub.filters.warehouse.control.value = $hub.inParams.warehouseId;
  }
  else {
  
      // Default to the first warehouse based on the users data access role
      const warehouse = (await $datasources.Locations.ds_get_warehouse_top1.get({})).result;
      if ($utils.isDefined(warehouse)) {
  
          const warehouseId = warehouse.Id;
  
          if ($utils.isDefined(warehouseId)) {
              $hub.filters.warehouse.control.value = warehouseId;
          }
  
      }
  
  }
  
  
  
  
  
  $hub.filters.inventory_date.control.value = $utils.date.now();
  
  
  //Apply operations
  await $hub.on_apply_operations();
  
  
  }
  on_owner_change(event = null) {
    return this.on_owner_changeInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_owner_changeInternal(
    $hub: FootPrintPortalManager_inventory_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  if ($utils.isDefined($hub.filters.owner.control.value)) {
  
      $hub.widgets.total_available_amount_widget.hidden = false;
      $hub.widgets.total_packaged_amount_widget.hidden = false;
  
      $hub.tabs.tasks.hidden = false;
  
  
      $hub.on_inventory_type_change();
  }
  else {
      $hub.widgets.total_available_amount_widget.hidden = true;
      $hub.widgets.total_packaged_amount_widget.hidden = true;
  
      $hub.tabs.tasks.hidden = true;
  
  
      $hub.tabs.inventory_by_lp.hidden = true;
      $hub.tabs.inventory_by_lot.hidden = true;
      $hub.tabs.inventory_by_material.hidden = true;
  }
  
  $hub.filters.project.control.value = null;
  
  
  //Apply operations
  await $hub.on_apply_operations();
  }
  on_project_change(event = null) {
    return this.on_project_changeInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_changeInternal(
    $hub: FootPrintPortalManager_inventory_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  const projectId = $hub.filters.project.control.value
  
  
  // Set Owner from Project
  if ($utils.isDefined(projectId) && !$utils.isDefined($hub.filters.owner.control.value)) {
      const project = (await $datasources.Owners.ds_get_project_by_projectId.get({
          projectId: projectId
      })).result;
     
      if ($utils.isDefined(project)) {
  
          $hub.filters.owner.control.value = project[0].OwnerId;
  
      }
  
  }
  
  }
  on_inventory_type_change(event = null) {
    return this.on_inventory_type_changeInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_inventory_type_changeInternal(
    $hub: FootPrintPortalManager_inventory_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  var inventoryType = $hub.filters.inventory_type.control.value;
  
  
  
  if (inventoryType == 2) {
      $hub.tabs.inventory_by_lp.hidden = false;
      $hub.tabs.inventory_by_lp.activate();
  
  
      $hub.filters.inventory_date.hidden = false;
      $hub.filters.inventory_date.control.value = $utils.date.now();
  
  
      $hub.tabs.inventory_by_lot.hidden = true;
      $hub.tabs.inventory_by_material.hidden = true;
      $hub.tabs.inventory_by_material_snapshot.hidden = true;
      $hub.tabs.inventory_by_lot_snapshot.hidden = true;
      $hub.tabs.inventory_by_pallet_snapshot.hidden = true;
  
  
  }
  else if (inventoryType == 3) {
      $hub.tabs.inventory_by_lot.hidden = false;
      $hub.tabs.inventory_by_lot.activate();
  
  
  
      $hub.filters.inventory_date.hidden = false;
      $hub.filters.inventory_date.control.value = $utils.date.now();
  
      $hub.tabs.inventory_by_lp.hidden = true;
      $hub.tabs.inventory_by_material.hidden = true;
      $hub.tabs.inventory_by_material_snapshot.hidden = true;
      $hub.tabs.inventory_by_lot_snapshot.hidden = true;
      $hub.tabs.inventory_by_pallet_snapshot.hidden = true;
  
  }
  else if (inventoryType == 4) {
      $hub.tabs.inventory_by_material.hidden = false;
      $hub.tabs.inventory_by_material.activate();
  
  
  
      $hub.filters.inventory_date.hidden = false;
      $hub.filters.inventory_date.control.value = $utils.date.now();
  
      $hub.tabs.inventory_by_lp.hidden = true;
      $hub.tabs.inventory_by_lot.hidden = true;
      $hub.tabs.inventory_by_material_snapshot.hidden = true;
      $hub.tabs.inventory_by_lot_snapshot.hidden = true;
      $hub.tabs.inventory_by_pallet_snapshot.hidden = true;
  
  }
  
  
  
  //Apply operations
  await $hub.on_apply_operations();
  }
  on_inventory_date_change(event = null) {
    return this.on_inventory_date_changeInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_inventory_date_changeInternal(
    $hub: FootPrintPortalManager_inventory_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  
  //let setDate = $utils.date.now();
  let hubSelectedDate = $hub.filters.inventory_date.control.value;
  
  const date = new Date($utils.date.now());
  const trimmedDate = date.toISOString().split("T")[0];
  
  const hubDate = new Date(hubSelectedDate);
  const trimmedHubDate = hubDate.toISOString().split("T")[0];
  
  const inventoryType = $hub.filters.inventory_type.control.value;
  
  if (trimmedHubDate > trimmedDate || trimmedHubDate < trimmedDate) {
  
      if (inventoryType == 2) {
          $hub.tabs.inventory_by_pallet_snapshot.hidden = false;
          $hub.tabs.inventory_by_pallet_snapshot.activate()
  
  
          $hub.tabs.inventory_by_lot.hidden = true;
          $hub.tabs.inventory_by_lp.hidden = true;
          $hub.tabs.inventory_by_material.hidden = true;
          $hub.tabs.inventory_by_material_snapshot.hidden = true;
          $hub.tabs.inventory_by_lot_snapshot.hidden = true;
      }
      else if (inventoryType == 3) {
          $hub.tabs.inventory_by_lot_snapshot.hidden = false;
          $hub.tabs.inventory_by_lot_snapshot.activate()
  
          $hub.tabs.inventory_by_lot.hidden = true;
          $hub.tabs.inventory_by_lp.hidden = true;
          $hub.tabs.inventory_by_material.hidden = true;
          $hub.tabs.inventory_by_material_snapshot.hidden = true;
          $hub.tabs.inventory_by_pallet_snapshot.hidden = true;
      }
  
      else if (inventoryType == 4) {
  
  
          $hub.tabs.inventory_by_material_snapshot.hidden = false;
          $hub.tabs.inventory_by_material_snapshot.activate()
  
          $hub.tabs.inventory_by_lot.hidden = true;
          $hub.tabs.inventory_by_lp.hidden = true;
          $hub.tabs.inventory_by_material.hidden = true;
          $hub.tabs.inventory_by_pallet_snapshot.hidden = true;
          $hub.tabs.inventory_by_lot_snapshot.hidden = true;
      }
  } else {
      if (inventoryType == 2) {
          $hub.tabs.inventory_by_lp.hidden = false;
  
          $hub.tabs.inventory_by_lp.activate()
  
          $hub.tabs.inventory_by_lot.hidden = true;
          $hub.tabs.inventory_by_material.hidden = true;
  
          $hub.tabs.inventory_by_pallet_snapshot.hidden = true;
          $hub.tabs.inventory_by_lot_snapshot.hidden = true;
          $hub.tabs.inventory_by_material_snapshot.hidden = true;
  
      }
      else if (inventoryType == 3) {
          $hub.tabs.inventory_by_lot.hidden = false;
  
          $hub.tabs.inventory_by_lot.activate()
          $hub.tabs.inventory_by_lp.hidden = true;
          $hub.tabs.inventory_by_material.hidden = true;
  
          $hub.tabs.inventory_by_pallet_snapshot.hidden = true;
          $hub.tabs.inventory_by_lot_snapshot.hidden = true;
          $hub.tabs.inventory_by_material_snapshot.hidden = true;
  
      }
  
      else if (inventoryType == 4) {
  
          $hub.tabs.inventory_by_material.hidden = false;
  
          $hub.tabs.inventory_by_material.activate()
  
          $hub.tabs.inventory_by_lp.hidden = true;
          $hub.tabs.inventory_by_lot.hidden = true;
  
          $hub.tabs.inventory_by_pallet_snapshot.hidden = true;
          $hub.tabs.inventory_by_lot_snapshot.hidden = true;
          $hub.tabs.inventory_by_material_snapshot.hidden = true;
  
      }
  
  }
  }
  on_create_material(event = null) {
    return this.on_create_materialInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_create_materialInternal(
    $hub: FootPrintPortalManager_inventory_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  const dialogResult = (await $shell.FootPrintPortalManager.openmaterial_creation_formDialog({
      ownerId: $hub.filters.owner.control.value,
      projectId: $hub.filters.project.control.value
      }));
  const userConfirm = dialogResult.confirm;
  if (userConfirm){
      await $hub.refresh();
  }
  }
  on_apply_operations(event = null) {
    return this.on_apply_operationsInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_apply_operationsInternal(
    $hub: FootPrintPortalManager_inventory_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  // Apply operations
  
  if (await $operations.FootPrintPortalManager.Disable_Inventory_Hub.isAuthorized()){
      $hub.close();
      $shell.FootPrintPortalManager.openErrorDialog('Authorization','You are not authorized to access the inventory hub.');
      
  }
  
  if (await $operations.FootPrintPortalManager.Disable_Inventory_DateSelection.isAuthorized()){
      $hub.filters.inventory_date.hidden = true;
  }
  
  if (await $operations.FootPrintPortalManager.Disable_Inventory_Activity.isAuthorized()){
      $hub.tabs.tasks.hidden = true;
  }
  
  if (await $operations.FootPrintPortalManager.Disable_Material_Creation.isAuthorized()){
      $hub.toolbar.create_material.hidden = true;
  }
  
  if (await $operations.FootPrintPortalManager.Disable_Lots_Hub.isAuthorized()){
      $hub.toolbar.lots_hub.hidden = true;
  }
  
  if (await $operations.FootPrintPortalManager.Disable_Serial_Hub.isAuthorized()){
      $hub.toolbar.serials_hub.hidden = true;
  }
  }
  on_lot_hub(event = null) {
    return this.on_lot_hubInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_lot_hubInternal(
    $hub: FootPrintPortalManager_inventory_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  
  const dialogResult = (await $shell.FootPrintPortalManager.openlots_hub({
      ownerId: $hub.filters.owner.control.value,
      projectId: $hub.filters.project.control.value
      }));
  
  }
  on_serial_hub(event = null) {
    return this.on_serial_hubInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_serial_hubInternal(
    $hub: FootPrintPortalManager_inventory_hubComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
  const dialogResult = (await $shell.FootPrintPortalManager.openserialnumbers_hub({
      ownerId: $hub.filters.owner.control.value,
      projectId: $hub.filters.project.control.value
      }));
  
  }
  //#endregion private flows
}
